import { Amplify } from 'aws-amplify'
import { getCurrentUser, fetchAuthSession, signOut } from 'aws-amplify/auth'

export const currentCredentials = async () => {
  const { username } = await getCurrentUser()
  const { tokens: session } = await fetchAuthSession()
  return {
    username,
    session
  }
}

export const logout = () => signOut()
